import * as Yup from "yup";

export const MaterialFormSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});
